const LaptopSoundType = {
    // Using same sound for Open and Close
    OPEN: "device_close",
    CLOSE: "device_close",

    NOTIFICATION: "laptop_notification",
    NEWFILE: "new_file_notification",

    CLICK: "click"
};

export default LaptopSoundType;